import { module } from 'modujs';

const CLASS = {
    ACTIVE: `is-active`
};

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                'controls' : 'changeItem'
            }
        }
    }

    init() {
        this.$('item')[0].classList.add(CLASS.ACTIVE)
        this.$('controls')[0].classList.add(CLASS.ACTIVE)
    }

    changeItem(e)  {
        let el = e.curTarget
        let index = Array.from(el.parentNode.children).indexOf(el)

        Array.from(this.$('item')).forEach((item) => {
            item.classList.remove(CLASS.ACTIVE)
        })

        Array.from(this.$('controls')).forEach((item) => {
            item.classList.remove(CLASS.ACTIVE)
        })
        this.$('item')[index].classList.add(CLASS.ACTIVE)
        this.$('controls')[index].classList.add(CLASS.ACTIVE)
    }
}
